// UserProfile.jsx
import React, { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Badge, Dropdown } from "antd";
import UserProfileCard from "../../card/UserCard/UserProfileCard";
import { useNotifications } from "../../../contexts/NotificationsContext.jsx";
import { useAuth } from "../../../hooks/auth";

const UserProfile = ({ collapsed, theme }) => {
  const { user, getTenantInfo } = useAuth();
  const { unread } = useNotifications();
  const tenantInfo = getTenantInfo();
  useEffect(() => {
    console.log("🔄 User:", user);
  }, [user]);
  const [open, setOpen] = useState(false);
  const userDropdownMenu = (
    <div style={{ padding: "16px" }}>
      <UserProfileCard
        tenant={tenantInfo}
        userName={user?.userName}
        user={user}
        userRole={user?.role}
        appVersion={"1.0.0"}
        onCloseDropdown={() => setOpen(false)}
      />
    </div>
  );

  return (
    <div
      style={{
        padding: "16px",
        marginTop: "auto",
      }}
    >
      <Dropdown
        dropdownRender={() => userDropdownMenu}
        trigger={["click"]}
        placement="topRight"
        open={open}
        onOpenChange={setOpen}
        destroyPopupOnHide
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: "12px",
            transition: "background-color 0.2s ease",
            background: "transparent",
          }}
        >
          <Badge count={unread} showZero={false} size="small" overflowCount={99} offset={[-16, -4]}>
            <div
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                background: user?.files ? `url(${user?.files}) center/cover` : theme.primary,
                marginRight: collapsed ? "0" : "12px",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {!user?.files && (user?.userName || user?.username)?.charAt(0)?.toUpperCase()}
            </div>
          </Badge>
          {!collapsed && (
            <>
              <div
                style={{
                  flex: 1,
                  transition: "all 0.3s ease",
                  lineHeight: "1.2",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                    lineHeight: "1.2",
                    color: theme.menuItemText || theme.textSecondary,
                  }}
                >
                  {user?.userName}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: theme.menuItemText || theme.textSecondary,
                  }}
                >
                  {tenantInfo?.nome}
                </div>
              </div>
              <DownOutlined
                style={{
                  color: theme.menuItemText || theme.textSecondary,
                  transition: "transform 0.2s ease",
                  marginLeft: "8px",
                  transform: "rotate(270deg)",
                }}
              />
            </>
          )}
        </div>
      </Dropdown>
    </div>
  );
};

export default UserProfile;
